import CryptoJS from 'crypto-js';
import querystring from 'querystring';
import { QcTip, QcNotification } from '@tencent/qcvue2';
import moment from 'moment';
import { CONSTANT } from './config';

const SystemClockOffset = 0; // 校正浏览器时间

export { querystring };
function uriEscape(string) {
  let output = encodeURIComponent(string);
  output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);

  output = output.replace(
    /[*]/g,
    ch => `%${ch
      .charCodeAt(0)
      .toString(16)
      .toUpperCase()}`,
  );

  return output;
}

export function queryStringParse(qs) {
  return querystring.parse(qs);
}

export function queryParamsToString(params) {
  const items = [];
  const escape = uriEscape;
  const sortedKeys = Object.keys(params).sort();

  sortedKeys.forEach(name => {
    const value = params[name];
    const ename = escape(name);
    let result = `${ename}=`;
    if (Array.isArray(value)) {
      const vals = [];
      value.forEach(item => {
        vals.push(escape(item));
      });
      result = `${ename}=${vals.sort().join(`&${ename}=`)}`;
    } else if (value !== undefined && value !== null) {
      result = `${ename}=${escape(value)}`;
    }
    items.push(result);
  });

  return items.join('&');
}

const iv = CryptoJS.enc.Utf8.parse(CONSTANT.IV); // 密钥偏移量
export const AES = {
  /**
   * AES 加密
   * @param {String} word 要加密的文本
   * @param {String} key 用来加密的密钥
   */
  encrypt(word, key) {
    return new Promise(resolve => {
      if (!word) {
        resolve();
        return;
      }
      try {
        const srcs = CryptoJS.enc.Utf8.parse(word);
        const accessCode = CryptoJS.enc.Utf8.parse(key); // 密钥
        const encrypted = CryptoJS.AES.encrypt(srcs, accessCode, {
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        const encryptedStr = encrypted.ciphertext.toString();
        resolve(encryptedStr);
      } catch (error) {
        resolve();
      }
    });
  },
  /**
   * AES 解密
   * @param {String} word 要解密的文本
   * @param {String} key 用来解密的密钥
   */
  decrypt(word, key) {
    return new Promise(resolve => {
      if (!word) {
        resolve();
        return;
      }
      try {
        const encryptedHexStr = CryptoJS.enc.Hex.parse(word);
        const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
        const accessCode = CryptoJS.enc.Utf8.parse(key); // 密钥
        const decrypt = CryptoJS.AES.decrypt(srcs, accessCode, {
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8).toString();
        resolve(decryptedStr);
      } catch (error) {
        console.log('decrypt -> error', error);
        resolve();
      }
    });
  },
  // 转为 base64 编码
  encodeToBase64(arr) {
    const rawStr = JSON.stringify(arr);
    const wordArray = CryptoJS.enc.Utf8.parse(rawStr);
    const base64 = CryptoJS.enc.Base64.stringify(wordArray);
    return base64;
  },
};

/**
 * tips 提示
 */
export const tips = {
  success(msg) {
    QcTip.success({ message: msg, duration: 2500 });
  },
  error(msg, content, time) {
    let duration = time;
    if (typeof duration === 'undefined') duration = 3000;
    if (!content) {
      return QcTip.error({ message: msg, duration });
    }
    return QcTip.error({ content, duration });
  },
  loading(msg) {
    if (!this.loadingTipHandler) {
      this.loadingTipHandler = QcTip.createTip({ type: 'loading', message: msg, duration: 0 });
      this.loadingTipHandler.update({ show: true });
    }
    const tipHandler = this.loadingTipHandler;
    tipHandler.update({
      message: msg,
    });
  },
  tips(options) {
    QcTip(options);
  },
  closeTips() {
    QcTip.close();
    if (this.loadingTipHandler) {
      this.loadingTipHandler.closeAndDestroy();
      this.loadingTipHandler = null;
    }
  },
  notification({ message, type = 'default', content = '' }) {
    const closeNotification = QcNotification.showNotification({
      message,
      content,
      type,
      duration: 0,
      onShowUpdate(show) {
        if (!show) {
          closeNotification();
        }
      },
    });
    return closeNotification;
  },
};

/**
 * 获取组件中使用的 props 的代理
 * @param {String} key
 * @param {Object} opt
 */
export function getInnerProps(key, opt) {
  const options = opt || { trim: true };

  const updateKey = `update:${key}`;

  return {
    get() {
      return this[key];
    },
    set(val) {
      let value = val;
      if (typeof val === 'string' && options.trim) {
        value = val.trim();
      }

      this.$emit(updateKey, value);
    },
  };
}

/**
 * 点击链接下载文件
 * @param {String} url
 */
export function downloadUrl(url) {
  // 使用 iframe 方式下载
  const id = 'downloadCosFile';
  const iframe = document.getElementById(id);
  iframe.id = 'downloadCosFile';
  iframe.src = url;
  setTimeout(() => {
    iframe.contentWindow.location.href = url;
  }, 100);

  // 使用 a 标签方式下载
  // const aTag = document.createElement('a');
  // aTag.target = '_blank';
  // aTag.href = url;
  // document.body.appendChild(aTag);
  // aTag.click();
  // setTimeout(() => {
  //   document.body.removeChild(aTag);
  // }, 100);
}

/**
 * 将 UTC 时间转换为时间戳
 * @param {String} date
 */
export function dateToUnix(date) {
  if (!date) return '-';
  return moment(date).unix();
}

/**
 * 格式化秒
 * @param {Number} second
 * @param {Number} num
 */
export function formatSecond(second, num) {
  const timeUnit = window.lang.t('core.time_unit');
  const unit = [timeUnit.ms, timeUnit.s, timeUnit.min, timeUnit.h, timeUnit.d, timeUnit.y];
  const d = [1000, 60, 60, 24, 365];
  let n = second * 1000;
  let index = 0;
  for (index = 0; index < unit.length && n >= d[index]; index += 1) n /= d[index];
  return n.toFixed(num || 0) + unit[index];
}

/**
 * 格式化时间
 * @param {Number} second
 * @param {Number} num
 */
export function formatTime(time, format) {
  if (time === '-') return time;
  return moment(time).format(format || 'YYYY-MM-DD HH:mm:ss');
}

/**
 * 判断传入的参数是否为数组类型
 * @param {*} arr
 */
export function isArray(arr) {
  return arr instanceof Array;
}

/**
 * 空函数
 */
export function noop() {}

export function guidByNum(num) {
  const str = new Array(num + 1).join('x');
  return str.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * 求字符串的字节数
 * @param {String} str
 * @param {String} charset
 */
export function getStringBytes(str, charset) {
  let total = 0;
  let charCode;
  charset = charset ? charset.toLowerCase() : '';
  if (charset === 'utf-16' || charset === 'utf16') {
    for (let i = 0, len = str.length; i < len; i++) {
      charCode = str.charCodeAt(i);
      if (charCode <= 0xffff) {
        total += 2;
      } else {
        total += 4;
      }
    }
  } else {
    for (let i = 0, len = str.length; i < len; i++) {
      charCode = str.charCodeAt(i);
      if (charCode <= 0x007f) {
        total += 1;
      } else if (charCode <= 0x07ff) {
        total += 2;
      } else if (charCode <= 0xffff) {
        total += 3;
      } else {
        total += 4;
      }
    }
  }
  return total;
}

/**
 * 获取数字对应的字符串描述（单位：KB MB GB TB PB）
 * @param {Number} size
 * @param {Number} base
 */
export function getSizeStr(size, base) {
  if (Number.isNaN(size)) {
    return '';
  }
  base = base * 1 || 1024;
  let result = '';
  const KBlevel = base;
  const MBlevel = KBlevel * base;
  const GBlevel = MBlevel * base;
  const TBlevel = GBlevel * base;
  const PBlevel = TBlevel * base;
  // size是Byte
  if (size < KBlevel) {
    result = `${size}B`;
  } else if (size < MBlevel) {
    result = `${(size / KBlevel).toFixed(2)}KB`;
  } else if (size < GBlevel) {
    result = `${(size / MBlevel).toFixed(2)}MB`;
  } else if (size < TBlevel) {
    result = `${(size / GBlevel).toFixed(2)}GB`;
  } else if (size < PBlevel) {
    result = `${(size / TBlevel).toFixed(2)}TB`;
  } else {
    result = `${(size / PBlevel).toFixed(2)}PB`;
  }
  return result;
}

/**
 * 获取拖拽事件中本地上传的文件列表
 * @param {DirectoryEntry} directory
 */
export function readDirectory(directory) {
  const files = [];
  let pending = 0;

  function getFiles(dirEntry, resolve, reject) {
    const dirReader = dirEntry.createReader();
    let entries = [];
    pending++;

    const getEntries = () => {
      dirReader.readEntries(results => {
        if (results.length) {
          entries = entries.concat(Array.from(results));
          getEntries();
        } else {
          pending--;
          entries.forEach(entry => {
            if (entry.isFile) {
              pending++;
              entry.file(File => {
                File.fullPath = entry.fullPath.replace('/', ''); // 去掉第一个/
                files.push(File);
                pending--;

                if (pending === 0) {
                  resolve(files);
                }
              }, reject);
            } else {
              const FolderObj = {
                isFolder: true,
                size: 0,
                fullPath: `${entry.fullPath.replace('/', '')}/`, // 去掉第一个/，尾部加上/
              };
              files.push(FolderObj);
              getFiles(entry, resolve, reject);
            }
          });

          if (pending === 0) {
            resolve(files);
          }
        }
      }, reject);
    };

    getEntries();
  }

  return new Promise((resolve, reject) => {
    getFiles(directory, resolve, reject);
  });
}

/**
 * 路径处理
 */
export const path = {
  extname(filename) {
    // 文件扩展名匹配正则
    const reg = /\.[^\.]+$/;
    const matches = reg.exec(filename);
    if (matches) {
      return matches[0];
    }
    return '';
  },
  dirname(filename) {
    const index = filename.lastIndexOf('/');
    return filename.substr(0, index);
  },
  basename(filename) {
    const index = filename.lastIndexOf('/');
    const ext = this.extname(filename);
    return filename.substr(index + 1).replace(ext, '');
  },
};

/**
 * 生成 uuid 随机序列
 */
export function getuuid() {
  const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  return `${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`;
}

/**
 * 功能：从 list 中移除与 removeList 中 key 相同的项
 * @param {*} removeList
 * @param {*} list
 */
export function removeFromList(removeList, list, removeKeys) {
  let _removeKeys = ['key', 'Key', 'versionId', 'VersionId'];
  if (removeKeys) {
    _removeKeys = _removeKeys.concat(removeKeys);
  }

  const needPopIdMap = {};
  removeList.forEach(item => {
    let key = '';
    _removeKeys.forEach(k => {
      key += item[k] || '';
    });
    needPopIdMap[key] = true;
  });
  // 从后往前移除
  for (let i = list.length - 1; i >= 0; i--) {
    let key = '';
    _removeKeys.forEach(k => {
      key += list[i][k] || '';
    });
    if (needPopIdMap[key]) {
      list.splice(i, 1);
    }
  }
  return list;
}

/**
 * 格式化文件大小
 */
export function formatSize(size) {
  size = parseFloat(size);
  const unit = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
  if (!Number.isFinite(size)) {
    return 0 + unit[0];
  }
  let index = 0;
  for (; index < unit.length && size >= 1024; index += 1) {
    size /= 1024;
  }
  return Math.round(size * 100) / 100 + unit[index];
}

/**
 * 匹配文件类型，区分显示图标
 */
function getIcons() {
  const mapping = {
    jpg: 'jpg,png,jpeg,gif,ico,bmp,svg,psd,tif',
    doc: 'doc,docx,wps,wpt,dot,dotx,docm,dotm,rtf,mht',
    mp3: 'mp3,cda,wav,wma,rma,mid,midi,ogg,aac,flac,ape,aiff,au,mod,xmi,rmi,cd',
    mp4: 'mp4,rmvb,mtv,mov,vcd,dat,mpeg,mpg,avi,rm,ra,asf,wmv,flv,swf,3gp,amv,dmv',
    pdf: 'pdf,xps',
    ppt: 'ppt,pptx,dps,dpt,pps,pot,pptm,potx,potm,ppsm,ppsx',
    txt: 'txt,html,yml,xhtml,htm,php,js,css,vue,md',
    xls: 'xls,xls,xlt,xltm,xlsm,et,ett,csv',
    zip: 'zip,rar,gz,tar,iso,dmg,7z,bz,bz2,cab',
    other: '',
  };
  const icon = {};
  Object.keys(mapping).forEach(key => {
    mapping[key].split(',').forEach(ext => {
      if (ext) {
        icon[ext] = key;
      }
    });
  });
  return icon;
}

export function getFileIcon(filename) {
  const icons = getIcons();
  const index = filename.lastIndexOf('.');
  const ext = index > -1 ? filename.substr(index + 1) : '';
  return icons[ext.toLowerCase()] || 'other';
}

// 判断是否可预览图片
export function isAllowPreviewImageKey(key) {
  return 'jpg|jpeg|png|webp|bmp|gif|ico|tiff'.split('|').includes(
    path
      .extname(key)
      .substr(1)
      .toLowerCase(),
  );
}
// 判断是否可预览视频
export function isAllowPreviewVideoKey(key) {
  return 'mp4|webm|ogv|ogg'.split('|').includes(
    path
      .extname(key)
      .substr(1)
      .toLowerCase(),
  );
}
// 判断是否可预览音频
export function isAllowPreviewAudioKey(key) {
  return 'mp3|wav'.split('|').includes(
    path
      .extname(key)
      .substr(1)
      .toLowerCase(),
  );
}

export const getNumberImg = (function getNumberImg() {
  const drawRoundRect = (ctx, x, y, w, h, r) => {
    ctx.beginPath();
    ctx.arc(x + r, y + r, r, Math.PI, (Math.PI * 3) / 2);
    ctx.lineTo(w - r + x, y);
    ctx.arc(w - r + x, r + y, r, (Math.PI * 3) / 2, Math.PI * 2);
    ctx.lineTo(w + x, h + y - r);
    ctx.arc(w - r + x, h - r + y, r, 0, Math.PI / 2);
    ctx.lineTo(r + x, h + y);
    ctx.arc(r + x, h - r + y, r, Math.PI / 2, Math.PI);
    ctx.fill();
    ctx.closePath();
  };
  const cached = {};
  const getImg = text => {
    text += '';
    if (cached[text]) {
      return cached[text];
    }
    const canvas = document.createElement('canvas');
    canvas.width = 200;
    canvas.height = 200;
    const ctx = canvas.getContext('2d');
    ctx.font = '12px sans-serif';
    let W = ctx.measureText(text).width;
    const H = 20;
    W = Math.ceil(W);
    W = W + 1 - ((W + 1) % 2);
    W = Math.max(W + 12, H);
    canvas.width = W;
    canvas.height = H;
    ctx.fillStyle = '#0068f2';
    drawRoundRect(ctx, 0, 0, W, H, H / 2);
    ctx.fillStyle = '#ffffff';
    ctx.font = '12px sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText(text, W / 2, H * 0.71);
    const url = canvas.toDataURL();
    const img = new Image();
    img.src = url;
    cached[text] = img;
    return img;
  };
  Array(35)
    .fill('')
    .forEach((item, index) => {
      getImg(index + 1);
    });
  return getImg;
}());

/**
 * 获取浏览器滚动条宽度
 */
let scrollbarWidth = 0; // 缓存浏览器滚动条宽度
export function getScrollbarWidth() {
  if (scrollbarWidth) return scrollbarWidth;

  const scrollDiv = document.createElement('div');
  scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
  document.body.appendChild(scrollDiv);
  scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

/**
 * 复制内容到剪切板
 * @param {String} text
 */
export function copyText2Clipboard(text, notips) {
  navigator.clipboard.writeText(text).then(() => {
    !notips && tips.success(window.lang.t('state.success.copy'));
  });
}

/**
 * 复制链接信息到剪切板
 * @param {String} text
 */
export function copyLink2Clipboard({
  link, isPrivate = false, duration = 2, unit = 'h',
}) {
  navigator.clipboard.writeText(link).then(() => {
    if (isPrivate) {
      tips.success(
        window.lang.t('cos.copy_files.success_with_sign', {
          duration,
          unit: window.lang.t(`core.time_unit.${unit}`),
        }),
      );
    } else {
      tips.success(window.lang.t('cos.copy_files.success_without_sign'));
    }
  });
}

// 序列化: obj 转 query string
export function serialize(obj) {
  const arr = [];
  Object.keys(obj)
    .sort()
    .forEach(item => {
      let value = obj[item];
      if (!value) {
        if (value === 0 || value === '0') {
          value = '0';
        } else {
          value = '';
        }
      }
      arr.push(`${item}=${value}`);
    });
  return arr.join('&');
}

/**
 * 云 API 计算签名
 * @param {String} method 请求方法
 * @param {Object} params 要签名的参数
 * @param {String} key 签名密钥
 */
export function getQcloudSign(method, params, key, host) {
  const formatString = serialize(params);
  const originSignature = `${method}${host}/?${formatString}`;

  const sha1Res = CryptoJS.HmacSHA1(originSignature, key);
  const sign = CryptoJS.enc.Base64.stringify(sha1Res);

  return encodeURIComponent(sign);
}

/**
 * 获取云 API 公共参数
 * @param {String} SecretId
 */
export function getQcloudApiCommonParams(SecretId) {
  // TODO: 需要校准时间
  const timestamp = Math.floor(Date.now() / 1000);
  const nonce = Math.round(Math.random() * (20000 - 10000) + 10000);
  const commonParams = {
    Timestamp: timestamp,
    Nonce: nonce,
    SecretId,
  };
  return commonParams;
}

/**
 * 对象降维
 * @param {Object} data 要降维的对象
 * @param {String} prefix 字符串前缀
 */
export function mergeData(data, prefix = '') {
  const ret = {};
  Object.keys(data).forEach(k => {
    if (data[k] !== null) {
      if (data[k] instanceof Array || data[k] instanceof Object) {
        Object.assign(ret, mergeData(data[k], `${prefix + k}.`));
      } else {
        ret[prefix + k] = data[k];
      }
    }
  });
  return ret;
}

/**
 * 获取当前时间
 * @param {Number} offset 偏移时间
 */
export function getSkewTime(offset) {
  return Date.now() + (offset || SystemClockOffset || 0);
}
